import {useState} from 'react'
import { ChatMessage, ChatRoom } from '@/core/models/chat-room.model'
import { Trans } from '@lingui/macro'
import { Typography } from '@mui/material'
import MessageReadersModal from './MessageReadersBox'

type MessageReadersProps = {
  message: ChatMessage
  chatRoomUsers?: ChatRoom['users']
}

export default function MessageReaders({ message, chatRoomUsers }: MessageReadersProps) {
  const [modalOpen, setModalOpen] = useState(false)
  
  const readerIds = message.readBy.filter((userId) => userId !== message.author)
  
  if (readerIds.length === 0) return null
  
  return (
    <>
      <Typography
        variant="caption"
        sx={{
          color: 'text.secondary',
          fontSize: '0.7rem',
          mt: 0.5,
          alignSelf: 'flex-end',
          cursor: 'pointer',
          textDecoration: 'underline',
        }}
        onClick={() => setModalOpen(true)}
      >
        <Trans>seen by {readerIds.length} people</Trans>
      </Typography>
      
      <MessageReadersModal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        message={message}
        chatRoomUsers={chatRoomUsers}
      />
    </>
  )
}
